var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12565"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9421",
    width: 24,
    height: 24,
    rx: 5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 935",
    d: "M8.779 17.424l-4.6-4.564a1.257 1.257 0 01-.376-.9 1.27 1.27 0 01.376-.9 1.334 1.334 0 01.913-.367 1.316 1.316 0 01.913.367l3.685 3.646 8.291-8.131a1.3 1.3 0 011.816 0 1.24 1.24 0 01.4.922 1.259 1.259 0 01-.4.922l-9.2 9a1.292 1.292 0 01-.908.371 1.305 1.305 0 01-.91-.366zm-4.781-5.463a1.061 1.061 0 00.32.758l4.6 4.561a1.1 1.1 0 001.534 0l9.2-9.008a1.058 1.058 0 00.343-.775 1.058 1.058 0 01-.343.775l-9.2 9.008a1.1 1.1 0 01-1.534 0l-4.6-4.561a1.061 1.061 0 01-.32-.758zm14.716-5.537a1.035 1.035 0 01.173-.016 1.023 1.023 0 00-.173.016z"
  })));
}
export default SvgCheck;